import {Component, ElementRef, EventEmitter, HostListener, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'brt-slider-input',
  templateUrl: './slider-input.component.html',
  styleUrls: ['./slider-input.component.scss']
})
export class SliderInputComponent {

  @Output("value") valueEmitter = new EventEmitter();
  @ViewChild("sliderInput") sliderInputElement: ElementRef = new ElementRef<any>(null)

  isDragging = false;
  value = 0;

  enableDrag() {
    this.isDragging = true;
  }

  @HostListener("window:mouseup", ['$event'])
  disableDrag() {
    this.isDragging = false;
  }

  @HostListener("window:mousemove", ['$event'])
  getDrag($event: MouseEvent) {
    if(this.isDragging && this.sliderInputElement) {
      const offsetOnBar = $event.clientX - this.sliderInputElement.nativeElement.offsetLeft;
      const percent = offsetOnBar / this.sliderInputElement.nativeElement.offsetWidth;
      this.value = Math.max(0, Math.min(1, percent));
      this.valueEmitter.emit(this.value);
    }

  }
}
